import styled from "styled-components";
import { 
  Space,
  Button as AntButton,
} from "antd";

// export const SubTitle = styled.div`
//   margin: 0 18px 24px;
//   color: var(--white, #FFF);
//   text-align: center;
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: normal;
// `;

export const StyledInput = styled.input`
  margin-top: 16px;
  width: 50px !important;
  height: 55px !important;
  border-radius: 12px !important;
  text-align: center !important;
  border:  ${(props) => (props.status === "error" ? "1px solid red" : "1px solid #DDD7CD")} !important;
  font-size: 16px !important;
  padding: 0;
  color: #000000 !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: #FFFFFF !important;

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 460px) {
    width: 56px !important;
    height: 65px !important;
  }
  @media screen and (max-width: 380px) {
    width: 45px !important;
    height: 50px !important;
  }
  @media screen and (max-width: 320px) {
    width: 40px !important;
    height: 40px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin: 16px 0;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled(AntButton)`
  cursor: pointer;
  color: #DADADA !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: none !important;

  :hover{
    color: #DADADA !important;
    background: none !important;
  }
`;

export const TimeText = styled.div`
  color: #FFFFFF;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;


